import { render, staticRenderFns } from "./stars-rating.vue?vue&type=template&id=542a91a4&scoped=true&"
import script from "./stars-rating.vue?vue&type=script&lang=js&"
export * from "./stars-rating.vue?vue&type=script&lang=js&"
import style0 from "./stars-rating.vue?vue&type=style&index=0&id=542a91a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a91a4",
  null
  
)

export default component.exports